<script setup lang="ts">
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'

  const route = useRoute()

  const title = computed(() =>
    typeof route.meta.title === 'function' ? route.meta.title(route) : route.meta.title
  )
</script>

<template>
  <div class="top-bar">
    <div class="page-title">{{ title }}</div>

    <div class="page-actions">
      <slot />
    </div>
  </div>
</template>

<style lang="css" scoped>
  .top-bar {
    position: sticky;
    top: 0;
    left: 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    gap: 1rem;
    align-items: center;
    background-color: var(--colours-grey-2);
    padding: 0 var(--spacing-m);
    height: var(--top-bar-height);
    border-bottom: 1px solid var(--colours-grey-3);
    z-index: 10;
  }

  .page-title {
    overflow: hidden;
    color: var(--colours-grey-5);
    text-overflow: ellipsis;

    font-family: Inter;
    font-size: var(--font-size-h1);
    font-style: normal;
    font-weight: 700;
  }

  .page-actions {
    display: flex;
    justify-content: end;
    align-items: center;
    gap: 0.75rem;
  }
</style>
